import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import alertIcon from './alertIcon';
import alertIcongrey from './alertIcongrey';
import alertLightIcon from './alertIconLight';
import arrowdownIcon from './arrowdownIcon';
import arrowrightIcon from './arrowrightIcon';
import blueIconCheckbox from './blueIconCheckbox';
import cameraIcon from './cameraIcon';
import checkokIcon from './checkokIcon';
import ckechVerifiedIcon from './checkVerified';
import clockIcon from './clock-icon';
import coupon from './coupon';
import couponCheckmark from './couponCheckmark';
import crossIcon from './crossIcon';
import crossModalIcon from './crossModalIcon';
import csv from './csv';
import dashIconAvGroups from './dashIconAvGroups';
import dashIconConversion from './dashIconConversion';
import dashIconGender from './dashIconGender';
import dashIconGroups from './dashIconGroups';
import dashIconPhotos from './dashIconPhotos';
import dashIconPrints from './dashIconPrints';
import dashIconSales from './dashIconSales';
import dashIconShares from './dashIconShares';
import dashIconValueTransaction from './dashIconValueTransaction';
import dashIconVisitors from './dashIconVisitors';
import dashIconWww from './dashIconWww';
import discountIcon from './discountIcon';
import discountIconBlue from './discountIconBlue';
import discountIconWhite from './discountIconWhite';
import docCodeIcon from './docCodeIcon';
import docCsvIcon from './docCsvIcon';
import docDownloadImg from './docDownloadImg';
import docPhotopassIcon from './docPhotopassIcon';
import docReloadIcon from './docReloadIcon';
import docVipIcon from './docVipIcon';
import docXlsIcon from './docXlsIcon';
import dollarIcon from './dollarIcon';
import downloadIcon from './downloadIcon';
import emailOpenIcon from './emailOpenIcon';
import eyeIcon from './eyeIcon';
import fileCashIcon from './fileCashIcon';
import fileDownloadIcon from './fileDownloadIcon';
import fileFontIcon from './fileFontIcon';
import filejpgIcon from './filejpgIcon';
import filePng from './filePng';
import filterIcon from './filterIcon';
import flagEn from './flagEn';
import gophotoIcon from './gophotoIcon';
import helpIcon from './helpIcon';
import iconCheckOk from './iconCheckOk';
import iconCross from './iconCross';
import iconDrag from './iconDrag';
import iconHome from './iconHome';
import informationIcon from './informationIcon';
import keyIcon from './keyIcon';
import linkIcon from './linkIcon';
import loadingIcon from './loadingIcon';
import loadingUpload from './loadingUpload';
import lockIcon from './lockIcon';
import loupeGreyIcon from './loupeGreyIcon';
import loupeIcon from './loupeIcon';
import menuDashboard from './menuDashboard';
import menuEcommerce from './menuEcommerce';
import menuMailing from './menuMailing';
import menuPhotocode from './menuPhotocode';
import menuPhotoExport from './menuPhotoExport';
import menuPhotographers from './menuPhotographers';
import menuPhotos from './menuPhotos';
import menuPrinting from './menuPrinting';
import menuScreenflow from './menuScreenflow';
import menuSettings from './menuSettings';
import menuStatistics from './menuStatistics';
import menuUserData from './menuUserData';
import menuVideos from './menuVideos';
import pagerNextIcon from './pagerNextIcon';
import pagerPrevIcon from './pagerPrevIcon';
import paperplaneIcon from './paperPlane';
import pencilIcon from './pencilIcon';
import peopleIcon from './peopleIcon';
import personIcon from './personIcon';
import photocode from './photocode';
import photocodeAvailableIcon from './photocodeAvailableIcon';
import photocodeCreatedIcon from './photocodeCreatedIcon';
import photocodeScannedIcon from './photocodeScannedIcon';
import photoIcon from './photoIcon';
import printIcon from './printIcon';
import qrcode from './qrcode';
import rotate from './rotate';
import shareIcon from './shareIcon';
import textalignCenter from './textalignCenter';
import textalignJustify from './textalignJustify';
import textalignLeft from './textalignLeft';
import textalignRight from './textalignRight';
import trashGreyIcon from './trashGreyIcon';
import trashIcon from './trashIcon';
import trashRedIcon from './trashRedIcon';
import unlockIcon from './unlockIcon';
import upDownArrow from './upDownArrow';
import uploadIcon from './uploadIcon';
import wwwIcon from './wwwIcon';
import inventoryIcon from './inventoryIcon';
import iconGroups from './iconGroups';
import hourglassIcon from './hourglass';
import closeIcon from './closeIcon';

@Component({
    selector: 'svg-icon',
    templateUrl: './icon.component.html',
})
export class IconComponent implements OnInit {
    currentIcon;
    iconList = {
        help: helpIcon,
        person: personIcon,
        people: peopleIcon,
        photo: photoIcon,
        www: wwwIcon,
        dollar: dollarIcon,
        pencil: pencilIcon,
        trash: trashIcon,
        'trash-red': trashRedIcon,
        'trash-grey': trashGreyIcon,
        gophoto: gophotoIcon,
        'arrow-down': arrowdownIcon,
        loupe: loupeIcon,
        loupeGrey: loupeGreyIcon,
        cross: crossIcon,
        alert: alertIcon,
        'photocode-available': photocodeAvailableIcon,
        'photocode-created': photocodeCreatedIcon,
        'photocode-scanned': photocodeScannedIcon,
        upload: uploadIcon,
        arrowright: arrowrightIcon,
        'file-jpg': filejpgIcon,
        'file-png': filePng,
        'file-font': fileFontIcon,
        filterIcon: filterIcon,
        checkok: checkokIcon,
        docXls: docXlsIcon,
        docCode: docCodeIcon,
        docCsv: docCsvIcon,
        docVip: docVipIcon,
        docReload: docReloadIcon,
        download: downloadIcon,
        eyeIcon: eyeIcon,
        print: printIcon,
        share: shareIcon,
        link: linkIcon,
        fileCash: fileCashIcon,
        pagerNext: pagerNextIcon,
        pagerPrev: pagerPrevIcon,
        emailOpen: emailOpenIcon,
        crossModal: crossModalIcon,
        'discount-used': discountIcon,
        'discount-available': discountIconBlue,
        'discount-created': discountIconWhite,
        fileDownload: fileDownloadIcon,
        flagEn: flagEn,
        textalignLeft: textalignLeft,
        textalignCenter: textalignCenter,
        textalignRight: textalignRight,
        textalignJustify: textalignJustify,
        docPhotopass: docPhotopassIcon,
        docDownloadImg: docDownloadImg,
        menuDashboard: menuDashboard,
        menuEcommerce: menuEcommerce,
        menuPhotocode: menuPhotocode,
        menuMailing: menuMailing,
        menuPhotos: menuPhotos,
        menuVideos: menuVideos,
        menuPhotoExport: menuPhotoExport,
        menuPhotographers: menuPhotographers,
        menuPrinting: menuPrinting,
        menuStatistics: menuStatistics,
        menuScreenflow: menuScreenflow,
        menuSettings: menuSettings,
        menuUserData: menuUserData,
        iconHome: iconHome,
        iconDrag: iconDrag,
        iconCheckOk: iconCheckOk,
        iconCross: iconCross,
        dashIconVisitors: dashIconVisitors,
        dashIconGroups: dashIconGroups,
        dashIconGender: dashIconGender,
        dashIconValueTransaction: dashIconValueTransaction,
        dashIconConversion: dashIconConversion,
        dashIconAvGroups: dashIconAvGroups,
        dashIconPhotos: dashIconPhotos,
        dashIconPrints: dashIconPrints,
        dashIconSales: dashIconSales,
        dashIconShares: dashIconShares,
        dashIconWww: dashIconWww,
        coupon: coupon,
        couponCheckmark: couponCheckmark,
        lock: lockIcon,
        unlock: unlockIcon,
        loading: loadingIcon,
        loadingUpload: loadingUpload,
        rotate: rotate,
        photocode: photocode,
        qrcode: qrcode,
        csv: csv,
        clockIcon: clockIcon,
        alertIconGrey: alertIcongrey,
        informationIcon: informationIcon,
        inventoryIcon: inventoryIcon,
        alertLightIcon: alertLightIcon,
        keyIcon: keyIcon,
        paperplaneIcon: paperplaneIcon,
        ckechVerifiedIcon: ckechVerifiedIcon,
        upDownArrow: upDownArrow,
        blueIconCheckbox: blueIconCheckbox,
        camera: cameraIcon,
        iconGroups: iconGroups,
        hourglassIcon,
        close: closeIcon,
    };

    @Input() icon: string;

    constructor(private sanitizer: DomSanitizer) {}

    ngOnInit() {
        this.getIcon(this.icon);
    }

    getIcon(name) {
        const svg = this.iconList[name];
        this.currentIcon = this.sanitizer.bypassSecurityTrustHtml(svg);
    }
}
